import useWindowFocus from 'use-window-focus';
import { isFirefox } from 'react-device-detect';

export const useShouldAskForFocus = (): boolean => {
  const windowFocused = useWindowFocus();

  return isFirefox && !windowFocused;
};
